<template>
  <div class="d-flex align-items-stretch dashboard">
    <!-- Loading -->
    <div v-show="loader" class="loader disable" style="margin-top: 16px"></div>
    <!-- Confirm logout dialog -->
    <confirm-dialog
      v-if="isShowLogoutDialog"
      :data="logoutDialog"
      @confirm="handleConfirmLogout"
    ></confirm-dialog>
    <!-- Desktop side navigation bar -->
    <side-navigation-bar
      v-if="isDesktop"
      class="sidebar-wrapper"
      @hideMobileNavBar="hideMobileNavBar"
      @showLogoutMenu="showLogoutMenu"
    ></side-navigation-bar>
    <!-- Page content -->
    <router-view
      class="page-wrapper"
      @showMobileNavBar="showMobileNavBar"
    ></router-view>
    <!-- Mobile navigation dialog -->
    <div v-if="isShowMobileNavBarDialog" class="dialog-bg">
      <div class="dialog-box">
        <div class="header">
          <p>{{ "เมนู" }}</p>
          <div class="close-btn" @click="hideMobileNavBar">
            <i class="fa fa-times"></i>
          </div>
        </div>
        <div class="content">
          <ul class="nav-bar">
            <profile></profile>
            <side-navigation-items
              @hideMobileNavBar="hideMobileNavBar"
              @showLogoutMenu="showLogoutMenu"
            ></side-navigation-items>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies"
import Profile from "../components/Profile"
import SideNavigationItems from "../components/SideNavigationItems"
import SideNavigationBar from "../components/SideNavigationBar"
import { mSize } from "../StaticVariable"

export default {
  name: "SupplierDashboard",
  components: {
    Profile,
    SideNavigationItems,
    SideNavigationBar,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      showMobileNavBarDialog: false,
      showLogoutDialog: false,
      logoutDialog: {
        title: "คุณต้องการออกจากระบบ",
        buttonCancel: "ยกเลิก",
        buttonSubmit: "ตกลง",
      },
    }
  },
  computed: {
    loader() {
      return this.$store.state.loader
    },
    isDesktop() {
      return this.windowWidth >= mSize
    },
    isShowMobileNavBarDialog() {
      return this.showMobileNavBarDialog
    },
    isShowLogoutDialog() {
      return this.showLogoutDialog
    },
  },
  async created() {
    this.checkAuth()
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize)
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth

      if (this.isDesktop) {
        this.hideMobileNavBar()
      }
    },
    showMobileNavBar() {
      this.showMobileNavBarDialog = true
    },
    hideMobileNavBar() {
      this.showMobileNavBarDialog = false
    },
    showLogoutMenu() {
      this.hideMobileNavBar()
      this.showLogoutDialog = true
    },
    hideLogoutMenu() {
      this.showLogoutDialog = false
    },
    checkAuth() {
      const token = localStorage.getItem("supplierAccessToken")
      if (!token) {
        this.$router.push({ name: "SupplierLogin" })
      }
    },
    async handleConfirmLogout(action) {
      if (action) {
        try {
          baanRueJaiClient.setAuthorizationToken()
        } catch (error) {
          // eslint-disable-next-line no-console
          console.debug(error)
        }

        localStorage.clear()
        this.$router.push({ name: "SupplierLogin" })
      } else {
        this.showLogoutDialog = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../css/otherWebVariables";
.dialog-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;

  > .dialog-box {
    background-color: $white;
    border-radius: 8px;
    width: 320px;
    max-height: 700px;
    overflow-y: auto;

    > .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: $supplier-primary-color;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;

      > p {
        padding-inline: 16px;
        padding-block: 8px;
        font-size: $font-18;
        font-weight: bold;
        color: $white;
      }

      > .close-btn {
        padding-inline: 16px;
        padding-block: 8px;
        color: $white;
        cursor: pointer;

        &:hover:not(:disabled) {
          opacity: 0.7;
        }
      }
    }

    > .content {
      display: flex;
      flex-direction: column;

      > .nav-bar {
        margin: 0;
        padding: 0;
        list-style: none;
        text-align: left;
      }
    }
  }
}

body {
  overflow-x: hidden;
}

.sidebar-wrapper {
  flex: 0 0 250px;
  width: 250px;
  background-color: $white;
  text-align: left;
  border-right: solid 1px $color-light-gray-1;
  overflow: auto;
}

.page-wrapper {
  width: calc(100% - 250px);
  padding-left: 0;
  text-align: left;
}

@media (max-width: ($m-size - 1)) {
  .page-wrapper {
    width: 100%;
  }
}

@media (min-width: $m-size) and (max-width: ($ml-size - 1)) {
  .sidebar-wrapper {
    flex: 0 0 190px;
    width: 190px;
  }

  .page-wrapper {
    width: calc(100% - 190px);
  }
}

@media (min-width: $ml-size) and (max-width: ($l-size - 1)) {
  .sidebar-wrapper {
    flex: 0 0 220px;
    width: 220px;
  }

  .page-wrapper {
    width: calc(100% - 220px);
  }
}
</style>
